var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "spec-Item-normal-container" },
    [
      _c(
        "el-row",
        { attrs: { gutter: 20, type: "flex", justify: "space-between" } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: {
                  value: _vm.item.specType,
                  placeholder: "请输入规格项",
                  size: "mini",
                  disabled: _vm.isOA
                },
                on: { input: _vm.specTypeChange }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 18 } },
            [
              _vm._l(_vm.item.specValue, function(tag, index) {
                return [
                  _vm.showInputEditIndex !== index
                    ? _c(
                        "el-tag",
                        {
                          key: tag,
                          attrs: {
                            closable: !_vm.isOA,
                            "disable-transitions": false
                          },
                          on: {
                            close: function($event) {
                              return _vm.handleClose(tag)
                            },
                            click: function($event) {
                              return _vm.showInputEdit(tag, index)
                            }
                          }
                        },
                        [_vm._v("\n          " + _vm._s(tag) + "\n        ")]
                      )
                    : _vm._e()
                ]
              }),
              _vm.item.specType.length && !_vm.isOA
                ? [
                    _vm.inputVisible
                      ? _c("el-input", {
                          ref: "saveTagInput",
                          staticClass: "input-new-tag",
                          attrs: { size: "small" },
                          on: { blur: _vm.handleInputConfirm },
                          nativeOn: {
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleInputConfirm($event)
                            }
                          },
                          model: {
                            value: _vm.inputValue,
                            callback: function($$v) {
                              _vm.inputValue = $$v
                            },
                            expression: "inputValue"
                          }
                        })
                      : _c(
                          "el-button",
                          {
                            staticClass: "button-new-tag",
                            attrs: { size: "small" },
                            on: { click: _vm.showInput }
                          },
                          [_vm._v("+ 添加规格值")]
                        )
                  ]
                : _vm._e()
            ],
            2
          ),
          _c(
            "el-col",
            { attrs: { span: 2 } },
            [
              !_vm.isOA
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "text" },
                      on: {
                        click: function($event) {
                          return _vm.$emit("deleteSpecItemEvent", _vm.item)
                        }
                      }
                    },
                    [_vm._v("删除")]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }